import { createBrowserHistory } from "history";
var history = createBrowserHistory();
history.listen(function (location, action) {
  console.log("The current URL is ".concat(location.pathname).concat(location.search).concat(location.hash));
  console.log("The last navigation action was ".concat(action));
});
export default history;